import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { MpAccessRestrictedComponent } from '../../features/member-portal-access/mp-access-restricted/mp-access-restricted.component';
import { AuthComponent } from './components/auth/auth.component';
import { SignInComponent } from './components/auth/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { MemberAuthViewModel } from './viewModels/member-auth-view-model';
import { UploadProfilePictureComponent } from './components/modals/upload-profile-picture/upload-profile-picture.component';
import { UploadProfilePictureViewModel } from './components/modals/upload-profile-picture/upload-profile-picture-view-model';
import { SignOutComponent } from './components/auth/sign-out/sign-out.component';
import { MemberWelcomeComponent } from './components/auth/member/member-welcome/member-welcome.component';
import { MemberSetupComponent } from './components/auth/member/member-setup/member-setup.component';
import { MemberEnterEmailVerificationComponent } from './components/auth/member/member-enter-email-verification/member-enter-email-verification.component';
import { MemberSendEmailVerificationComponent } from './components/auth/member/member-send-email-verification/member-send-email-verification.component';
import { InternalUserAuthSetupComponent } from './components/auth/internal-user/internal-user-auth-setup/internal-user-auth-setup.component';
import { QrCodeSupportComponent } from './components/modals/qr-code-support/qr-code-support.component';
import { MemberAuthComponent } from './components/auth/member/member-auth.component';
import { InternalUserAuthWrapperComponent } from './components/auth/wrappers/internal-user-auth-wrapper/internal-user-auth-wrapper.component';
import { AuthWrapperComponent } from './components/auth/wrappers/auth-wrapper/auth-wrapper.component';
import { InternalUserAuthComponent } from './components/auth/internal-user/internal-user-auth.component';
import { InternalUserVerifyCodeComponent } from './components/auth/internal-user/internal-user-verify-code/internal-user-verify-code.component';
import { EmployerAuthComponent } from './components/auth/employer/employer-auth.component';
import { InternalUserChoosePasswordComponent } from './components/auth/internal-user/internal-user-choose-password/internal-user-choose-password.component';
import { EmployerChoosePasswordComponent } from './components/auth/employer/employer-choose-password/employer-choose-password.component';
import { MobileAuthNavbarComponent } from './components/auth/mobile-auth-navbar/mobile-auth-navbar.component';
import { VerifyMfaComponent } from './components/auth/verify-mfa/verify-mfa.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionExpiryInterceptor } from '../../services/interceptors/session-expiry.interceptor';
import { MpSelfEnrolmentComponent } from './components/auth/mp-self-enrolment/mp-self-enrolment.component';
import { MpSelfEnrolmentPersonalInformationComponent } from './components/auth/mp-self-enrolment/mp-self-enrolment-personal-information/mp-self-enrolment-personal-information.component';
import { MpSelfEnrolmentContactInformationComponent } from './components/auth/mp-self-enrolment/mp-self-enrolment-contact-information/mp-self-enrolment-contact-information.component';
import { MpSelfEnrolmentLoginDetailsComponent } from './components/auth/mp-self-enrolment/mp-self-enrolment-login-details/mp-self-enrolment-login-details.component';
import { LoadingShimmerModule } from 'loading-shimmer';
import { EpSelfEnrolmentComponent } from './components/auth/ep-self-enrolment/ep-self-enrolment.component';
import { EpSelfEnrolmentEmployerInfoComponent } from './components/auth/ep-self-enrolment/ep-self-enrolment-employer-info/ep-self-enrolment-employer-info.component';
import { EpSelfEnrolmentContactPersonnelComponent } from './components/auth/ep-self-enrolment/ep-self-enrolment-contact-personnel/ep-self-enrolment-contact-personnel.component';
import { EpSelfEnrolmentAboutComponent } from './components/auth/ep-self-enrolment/ep-self-enrolment-employer-info/ep-self-enrolment-about/ep-self-enrolment-about.component';
import { EpSelfEnrolmentEmployerLogoComponent } from './components/auth/ep-self-enrolment/ep-self-enrolment-employer-info/ep-self-enrolment-employer-logo/ep-self-enrolment-employer-logo.component';

@NgModule({
  declarations: [
    AuthComponent,
    SignInComponent,
    SignOutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    UploadProfilePictureComponent,
    MemberWelcomeComponent,
    MemberSetupComponent,
    MemberEnterEmailVerificationComponent,
    MemberSendEmailVerificationComponent,
    InternalUserChoosePasswordComponent,
    InternalUserAuthSetupComponent,
    QrCodeSupportComponent,
    MemberAuthComponent,
    InternalUserAuthWrapperComponent,
    AuthWrapperComponent,
    InternalUserAuthComponent,
    InternalUserVerifyCodeComponent,
    MobileAuthNavbarComponent,
    InternalUserVerifyCodeComponent,
    EmployerAuthComponent,
    EmployerChoosePasswordComponent,
    VerifyMfaComponent,
    MpSelfEnrolmentComponent,
    MpSelfEnrolmentPersonalInformationComponent,
    MpSelfEnrolmentContactInformationComponent,
    MpSelfEnrolmentLoginDetailsComponent,
    EpSelfEnrolmentComponent,
    EpSelfEnrolmentEmployerInfoComponent,
    EpSelfEnrolmentContactPersonnelComponent,
    EpSelfEnrolmentAboutComponent,
    EpSelfEnrolmentEmployerLogoComponent,
  ],
  imports: [
    AuthRoutingModule,
    CommonModule,
    FormsModule,
    SharedModule,
    LoadingShimmerModule,
    MpAccessRestrictedComponent,
  ],
  providers: [
    MemberAuthViewModel,
    UploadProfilePictureViewModel,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpiryInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
